// extracted by mini-css-extract-plugin
export default {"main_nav":"NavBar_main_nav__u9ARo","_logo":"NavBar__logo__0JdE2","row":"NavBar_row__d9r6o","_avatar":"NavBar__avatar__6e8xi","name":"NavBar_name__ZJ1GH"};